export default __webpack_public_path__ + "static/media/example_company_3.45ded4e8.webp";